import { Link } from "react-router";
import { useBrand } from "@/app/tenant-provider";
import { BrandLogo } from "@/components/brand/brand-logo";
import { initials } from "@/domain/tenant/brand";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import { NavMain } from "@/components/layout/nav-main";
import { NavUser } from "@/components/layout/nav-user";
import type { NavEntry } from "@/components/layout/nav-items";

export function AppSidebar({
  items,
  userLabel,
  userDescription,
  userEmail,
}: {
  items: NavEntry[];
  userLabel: string;
  userDescription?: string;
  userEmail: string;
}) {
  const brand = useBrand();
  return (
    <Sidebar collapsible="icon">
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton size="lg" render={<Link to="/home" />}>
              {brand.logoUrl ? (
                <>
                  <BrandLogo src={brand.logoUrl} alt={brand.name} className="size-8 shrink-0 object-contain" />
                  {brand.logoIsDefault ? <span className="truncate font-semibold">{brand.name}</span> : null}
                </>
              ) : (
                <>
                  <span
                    aria-hidden="true"
                    className="flex size-8 shrink-0 items-center justify-center rounded-md bg-primary text-sm font-semibold text-primary-foreground"
                  >
                    {initials(brand.name)}
                  </span>
                  <span className="truncate font-semibold">{brand.name}</span>
                </>
              )}
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={items} />
      </SidebarContent>
      <SidebarFooter>
        <NavUser label={userLabel} description={userDescription} email={userEmail} />
      </SidebarFooter>
    </Sidebar>
  );
}
